import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Prism from 'prismjs';
import { SharedService } from 'src/app/shared/shared.service';
import { AbstractListComponent } from '../../../model/AbstractListComponent';
import { ListProveFinaliDTO } from './../../../model/newModel';
import { ElencoProveService } from './elenco-prove.service';

@Component({
  selector: 'app-elenco-prove',
  templateUrl: './elenco-prove.component.html',
  styleUrls: ['./elenco-prove.component.css'],
})
export class ElencoProveComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  listProveFinali: ListProveFinaliDTO;
  abilitatoDisabilitato = 'ATTIVI';
  showProveFinali: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    this.getList(this.abilitatoDisabilitato);
  }

  getList(abilitatoDisabilitato: string) {
    this.spinner.show();
    this.elencoProveService.search(abilitatoDisabilitato).subscribe(
      (result) => {
        this.listProveFinali = result;
        this.calcolaListVaiA(this.listProveFinali.pages);
        this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
        if (this.listProveFinali.proveFinali.length > 0) {
          this.showProveFinali = true;
        } else {
          this.showProveFinali = false;
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private elencoProveService: ElencoProveService
  ) {
    super();
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.elencoProveService
      .nextPage(this.abilitatoDisabilitato, skip, take, count)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search next');
          this.spinner.hide();
        }
      );
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.elencoProveService
      .goToPage(this.abilitatoDisabilitato, idVaiA, this.listProveFinali.take)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.elencoProveService
      .previousPage(this.abilitatoDisabilitato, skip, take)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search previous');
          this.spinner.hide();
        }
      );
  }
}
